// src/utils/dateUtils.js

/**
 * Returns both attributeTime and formattedLocalTime in the required formats.
 */
export const formatTimestamps = (dateObj = new Date()) => {
  const today = dateObj
  const date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
    2,
    '0'
  )}-${String(today.getDate()).padStart(2, '0')}`
  const time = `${String(today.getHours()).padStart(2, '0')}:${String(
    today.getMinutes()
  ).padStart(2, '0')}:${String(today.getSeconds()).padStart(2, '0')}`
  const dateTime = `${date} ${time}`

  const attributeTime = new Date(dateTime).toISOString().split('.')[0] + 'Z'

  const local = new Date(dateTime).toLocaleString()
  // Remove AM/PM and any uppercase letters (including timezone)
  const localWithoutAmPm = local.replace(/\s?(AM|PM)/gi, '')
  const localWithoutTimezone = localWithoutAmPm.replace(/[A-Z]/g, '')
  const [localDate, localTime] = localWithoutTimezone
    .split(',')
    .map((part) => part.trim())

  const [month, day, year] = localDate
    .split('/')
    .map((num) => num.padStart(2, '0'))
  const [hours, minutes, seconds] = localTime
    .split(':')
    .map((num) => num.padStart(2, '0'))

  const formattedLocalTime = `${year}${month}${day}_${hours}${minutes}${seconds}`

  return {
    attributeTime,
    formattedLocalTime,
  }
}